import React from "react";

import { FireIcon } from "@components/OrderTaking/Components/Icons/FireIcon";

import { FLAME_COLOR } from "./tokens";
import type { OrderEnergy } from "./useOrderEnergy";

/** Pure presentational view — no hook, no Redux subscription.
 *  The root stays in the DOM even when `!energy.visible` so the live region
 *  is registered before the first cart update (some SR engines ignore live
 *  regions that mount after page load — WCAG 4.1.3). */
export function KcalInlineView({
    energy,
}: {
    energy: OrderEnergy;
}): JSX.Element {
    const hidden = !energy.visible;
    return (
        <span
            className={
                hidden ? "kcal-inline kcal-inline--hidden" : "kcal-inline"
            }
            aria-hidden={hidden || undefined}
        >
            <span aria-hidden className="kcal-inline__icon">
                <FireIcon color={FLAME_COLOR} width="100%" height="100%" />
            </span>
            <span
                className="kcal-inline__text"
                aria-live="polite"
                aria-atomic="true"
            >
                {hidden ? "" : energy.kcalText}
            </span>
        </span>
    );
}
